module.exports = __webpack_public_path__ + "media/img/vca/bg-popup-2023-4b8670bc6d696514440c5a4906cad9a4.png";